import React from 'react';

const TroubleshootingSummary = () => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto" data-testid="troubleshooting-summary-page">
      <div className="panel-header">
        <div>
          <div className="panel-title">Troubleshooting</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight mt-2">Troubleshooting Summary</h1>
          <p className="text-sm md:text-base text-[var(--text-secondary)] mt-2 max-w-2xl">
            In a future iteration this page will summarize your recent troubleshooting activity, issues
            you have worked through, and notes you have captured. For now it serves as a structural
            placeholder.
          </p>
        </div>
      </div>

      <div className="panel text-sm text-[var(--text-secondary)]">
        <p>
          Use the machine or software wizards to view and record troubleshooting attempts. A consolidated
          timeline view will appear here in a future release.
        </p>
      </div>
    </div>
  );
};

export default TroubleshootingSummary;
